import { Trans, useTranslation } from "next-i18next"
import styles from "./BringToFriends.module.scss"
import { Balancer } from "react-wrap-balancer"

const BringToFriends = () => {
  const { t } = useTranslation("common")

  return (
    <section className={styles.section}>
      <h4 className={styles.h3}>
        <Balancer>{t("bring-olympiad-to-friends.title")}</Balancer>
      </h4>
      <p className={styles.p}>
        <Balancer>
          <Trans
            t={t}
            i18nKey="bring-olympiad-to-friends.description"
            components={[
              <a
                key="0"
                href="mailto:sabmia@climatescience.org"
                target="_blank"
                rel="noreferrer"
                className={styles.a}
              />,
            ]}
          />
        </Balancer>
      </p>
    </section>
  )
}

export default BringToFriends
